import moment from "moment"
import { formatCurrency } from "./Formatters"

export function calcLeasePayment(msrp, residual, moneyFactor, term, down, trade, payoff) {
  let residualValue = (msrp * residual / 100)
  let depreciation = (msrp - residualValue - parseInt(trade) - parseInt(down) + parseInt(payoff)) / term
  let financeFee = (msrp + residualValue) * moneyFactor
  let payment = depreciation + financeFee
  return payment > 0 ? parseInt(payment) : 0    
}

export function calcFinancePayment(principal, apr, term, down, trade, payoff) {
  let rate = apr / 1200
  let payment = 0
  let capCost = principal - parseInt(trade) - parseInt(down) + parseInt(payoff)
  if (rate > 0) {
    payment = capCost * (rate * ((rate + 1)**term)) / (((1 + rate)**term) - 1)
  } else {
    payment = capCost / term
  }
  return payment > 0 ? parseInt(payment) : 0
}

export function rollupLeaseCashDown(payment, msrp, residual, moneyFactor, term, trade, payoff) {
  let residualValue = (msrp * residual / 100)
  let financeFee = (msrp + residualValue) * moneyFactor
  return parseInt(msrp - residualValue - parseInt(trade) + parseInt(payoff) - ((payment - financeFee) * term))
}

export function rollupFinanceCashDown(payment, principal, apr, term, trade, payoff) {
  let rate = apr / 1200
  return parseInt(principal - (payment / ((rate * ((rate + 1)**term)) / (((1 + rate)**term) - 1))) - parseInt(trade) + parseInt(payoff))
}

export function calcCashPayment(principal, trade, payoff) {
  let payment = principal - parseInt(trade) + parseInt(payoff)
  return payment > 0 ? parseInt(payment) : 0
}

export function calcFinancePrice(payment, apr, term, down, trade, payoff) {
  const rate = parseFloat(apr) / 1200
  const loanTerm = parseInt(term)
  let rateFactor = (rate * ((rate + 1)**loanTerm)) / (((1 + rate)**loanTerm) - 1)
  let price = (parseInt(payment) / rateFactor) + (trade ? parseInt(trade) : 0) - (payoff ? parseInt(payoff) : 0) + (down ? parseInt(down) : 0)
  return parseInt(price)
}

export function buildCreditTiersDD(options) {
  return options.map(item => {
    return { id: item.tier, label: item.label }
  })
}

export function buildTermsDD(options) {
  return options.map(item => {
    return { id: parseInt(item), label: item }
  })
}

export function buildMilesDD(options) {
  return options.map(item => {
    return { id: parseInt(item), label: item }
  })
}

export function getDefaultAPR(car, creditTier) {
  return car.conditon == 1 ? creditTier.new_car_apr : car.condition == 2 ? creditTier.used_car_apr : creditTier.certified_car_apr
}

export function getDefaultSearchAPR(creditTier) {
  return (creditTier.new_car_apr + creditTier.used_car_apr + creditTier.certified_car_apr) / 3
}

export function disclaimer(site, dealType, payment) {
  let s = dealType ? site.dr[dealType].disclaimer : site.dr.disclaimer
  if (!s) return ""
  s = s.replaceAll('[payment]', formatCurrency(payment.monthly))
  s = s.replaceAll('[apr]', payment.apr)
  s = s.replaceAll('[down]', formatCurrency(payment.down))
  s = s.replaceAll('[expires]', moment().endOf("month").format("MM/DD/YYYY"))
  s = s.replaceAll('[term]', parseInt(payment.term))
  s = s.replaceAll('[miles]', parseInt(payment.miles))
  s = s.replaceAll('[trade]',  formatCurrency(payment.trade))
  return s
}